module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    staticClass: "ritem-card",
    attrs: {
      "role": "link",
      "tabindex": "0",
      "aria-label": 'View run ' + _vm.info.name
    },
    on: {
      "click": _vm.openRun,
      "keydown": [function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        $event.preventDefault();
        return _vm.openRun.apply(null, arguments)
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])) { return null; }
        $event.preventDefault();
        return _vm.openRun.apply(null, arguments)
      }]
    }
  }, [_c('div', {
    staticClass: "ritem-media",
    class: {
      'ritem-media--empty': !_vm.raceImageUrl
    }
  }, [(_vm.raceImageUrl) ? _c('img', {
    staticClass: "ritem-image",
    attrs: {
      "src": _vm.raceImageUrl,
      "alt": ""
    }
  }) : _c('svg', {
    attrs: {
      "width": "22",
      "height": "22",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "1.8",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('rect', {
    attrs: {
      "x": "3",
      "y": "3",
      "width": "18",
      "height": "18",
      "rx": "2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "8.5",
      "cy": "8.5",
      "r": "1.5"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M21 15l-5-5L5 21"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "ritem-body"
  }, [_c('div', {
    staticClass: "ritem-topline"
  }, [_c('span', {
    staticClass: "ritem-status"
  }, [_vm._v(_vm._s(_vm.statusLabel))]), _vm._v(" "), _c('span', {
    staticClass: "ritem-date"
  }, [_vm._v(_vm._s(_vm._f("date")(_vm.info.date)))])]), _vm._v(" "), _c('h3', {
    staticClass: "ritem-title"
  }, [_vm._v(_vm._s(_vm.info.name))]), _vm._v(" "), _c('div', {
    staticClass: "ritem-chip-row"
  }, [(_vm.durationLabel) ? _c('span', {
    staticClass: "ritem-chip ritem-chip--duration"
  }, [_c('svg', {
    attrs: {
      "width": "11",
      "height": "11",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2.1",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "12",
      "cy": "12",
      "r": "9"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M12 7v5l3 2"
    }
  })]), _vm._v("\n        " + _vm._s(_vm.durationLabel) + "\n      ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.typeChips), function(typeName) {
    return _c('span', {
      key: 'type-' + typeName,
      staticClass: "ritem-chip ritem-chip--type"
    }, [_vm._v("\n        " + _vm._s(_vm.formatChip(typeName)) + "\n      ")])
  }), _vm._v(" "), (!_vm.typeChips.length) ? _c('span', {
    staticClass: "ritem-chip ritem-chip--muted"
  }, [_vm._v("No type")]) : _vm._e()], 2), _vm._v(" "), (_vm.visibleTags.length) ? _c('div', {
    staticClass: "ritem-chip-row ritem-chip-row--tags"
  }, [_vm._l((_vm.visibleTags), function(tag) {
    return _c('span', {
      key: 'tag-' + tag.id,
      staticClass: "ritem-chip ritem-chip--tag"
    }, [_vm._v("\n        " + _vm._s(tag.name) + "\n      ")])
  }), _vm._v(" "), (_vm.hiddenTagCount > 0) ? _c('span', {
    staticClass: "ritem-chip ritem-chip--muted"
  }, [_vm._v("+" + _vm._s(_vm.hiddenTagCount))]) : _vm._e()], 2) : _vm._e(), _vm._v(" "), (_vm.hasActionDetails) ? _c('div', {
    staticClass: "ritem-action-meta"
  }, [(_vm.actionImageUrl) ? _c('img', {
    staticClass: "ritem-action-image",
    attrs: {
      "src": _vm.actionImageUrl,
      "alt": ""
    }
  }) : _c('span', {
    staticClass: "ritem-action-icon"
  }, [_c('svg', {
    attrs: {
      "width": "13",
      "height": "13",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2.1",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('path', {
    attrs: {
      "d": "M15 3h6v6"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M10 14L21 3"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"
    }
  })])]), _vm._v(" "), _c('span', {
    staticClass: "ritem-action-text",
    attrs: {
      "title": _vm.actionMetaText
    }
  }, [_vm._v(_vm._s(_vm.actionMetaText))]), _vm._v(" "), (_vm.actionUrl) ? _c('a', {
    staticClass: "ritem-action-open",
    attrs: {
      "href": _vm.actionUrl,
      "target": "_blank",
      "rel": "noopener noreferrer",
      "title": "Open action URL"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('svg', {
    attrs: {
      "width": "13",
      "height": "13",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2.1",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('path', {
    attrs: {
      "d": "M15 3h6v6"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M10 14L21 3"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"
    }
  })])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "ritem-actions"
  }, [_c('div', {
    staticClass: "ritem-icon-actions"
  }, [_c('router-link', {
    staticClass: "ritem-edit-btn",
    attrs: {
      "to": {
        path: _vm.editPath
      },
      "title": "Edit run"
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('svg', {
    attrs: {
      "width": "13",
      "height": "13",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2.1",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('path', {
    attrs: {
      "d": "M12 20h9"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M16.5 3.5a2.12 2.12 0 0 1 3 3L7 19l-4 1 1-4Z"
    }
  })])]), _vm._v(" "), (_vm.$isDevMode()) ? _c('button', {
    staticClass: "ritem-delete-btn",
    attrs: {
      "title": "Dev: Delete this race"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.$emit('delete', _vm.info.id)
      }
    }
  }, [_c('svg', {
    attrs: {
      "width": "13",
      "height": "13",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2.1",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('path', {
    attrs: {
      "d": "M3 6h18"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M10 11v6M14 11v6"
    }
  })])]) : _vm._e()], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-386ebd86"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Race/RaceItem.vue
// module id = 1696
// module chunks = 2